import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function Contact() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section
      id="contact"
      ref={ref}
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-3xl mx-auto text-center">
        <div
          className={`section-animate ${isVisible ? "visible" : ""} mb-4 md:mb-6`}
        >
          <p className="text-xs md:text-sm tracking-[0.3em] text-text-muted mb-2">
            CONTACT
          </p>
        </div>

        <h2
          className={`section-animate section-animate-delay-1 ${
            isVisible ? "visible" : ""
          } text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-snug tracking-tight text-white mb-6 md:mb-8`}
        >
          事業に関するご相談
        </h2>

        <p
          className={`section-animate section-animate-delay-2 ${
            isVisible ? "visible" : ""
          } text-sm md:text-base text-text-secondary leading-relaxed mb-10 md:mb-12`}
        >
          ご相談内容を確認のうえ、担当者よりご連絡します。
        </p>

        <div
          className={`section-animate section-animate-delay-3 ${
            isVisible ? "visible" : ""
          }`}
        >
          <a
            href="mailto:info@lob-official.com"
            className="inline-flex items-center gap-3 px-8 py-4 bg-accent text-white text-sm md:text-base tracking-[0.1em] font-medium hover:bg-accent-light transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-lg" />
            <span>info@lob-official.com</span>
          </a>
        </div>
      </div>
    </section>
  );
}